export const SIDEBAR_PANEL = 'bg-[#fafafa]';
export const SIDEBAR_LINE = 'border-[#e5e5e5]';
export const SIDEBAR_LINE_FILL = 'bg-[#e5e5e5]';
export const SIDEBAR_TEXT_COLOR = 'text-[#737373]';
export const SIDEBAR_TEXT_ACTIVE = 'text-[#171717]';
export const SIDEBAR_TEXT_DISABLED = 'text-[#a3a3a3]';
export const SIDEBAR_FILL = 'bg-[#e5e5e573]';

export const SIDEBAR_ROW_REST = 'text-[#737373] hover:bg-[#e5e5e573] hover:text-[#171717]';
export const SIDEBAR_ROW_ACTIVE = 'bg-[#e5e5e573] text-[#171717]';
export const SIDEBAR_ROW_DISABLED = 'cursor-default text-[#a3a3a3]';
export const SIDEBAR_ROW_FOCUS = 'focus-visible:bg-[#e5e5e573] focus-visible:text-[#171717]';
export const SIDEBAR_ICON_HOVER = 'group-hover/row:text-[#171717]';

export const SIDEBAR_DUO_FILL =
  "[&_[data-color='color-2']]:fill-[#e5e5e5] [&_[data-color='color-2']]:[fill-opacity:1] [&_[data-color='color-2']]:opacity-100";

export const SIDEBAR_CARD = 'bg-[#ffffff] ring-[#e5e5e5] hover:bg-[#fafafa]';
export const SIDEBAR_CARD_RAIL = 'bg-transparent ring-transparent hover:bg-[#e5e5e573]';

export const SIDEBAR_FLYOUT_SURFACE = {
  background: 'bg-[#ffffff]',
  border: 'border border-solid border-[#e5e5e5]',
  rounded: 'rounded-12',
  shadow: 'shadow-02',
};

export const SIDEBAR_TEXT = 'text-[1.4rem] font-medium leading-[2rem]';
export const SIDEBAR_LABEL_TRANSITION = 'transition-[opacity,transform] duration-150 ease-linear';
export const SIDEBAR_LABEL_HIDDEN = 'translate-x-4 opacity-0';
export const SIDEBAR_FOCUS_RING =
  'outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#171717]';

export const TOP_BAR_ACTION_TEXT = 'text-[#525252] hover:text-[#404040]';
export const TOP_BAR_ACTION_BORDER = 'border-[#d4d4d4]';
export const TOP_BAR_ACTION_RING = 'ring-[#d4d4d4]';
export const TOP_BAR_ACTION_HOVER = 'hover:bg-[#fafafa]';
export const TOP_BAR_ACTION_OPEN = 'bg-[#fafafa]';
export const TOP_BAR_ICON_TEXT = 'text-[#a3a3a3] hover:text-[#737373]';
export const TOP_BAR_ICON_SURFACE = 'bg-[#ffffff]';
export const TOP_BAR_AI_ICON_TEXT = 'text-[#737373]';
